/**
 * Privacy Policy Page - /privacy
 * Public route, no auth required.
 *
 * The canonical Privacy Policy lives on the marketing site (single source of
 * truth). This route forwards there to prevent the drift that came from
 * maintaining a second hardcoded copy. See CanonicalLegalRedirect.
 */
import { createFileRoute } from '@tanstack/react-router';
import { CanonicalLegalRedirect } from '@/components/legal/CanonicalLegalRedirect';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <CanonicalLegalRedirect
      doc="privacy"
      titleKey="legalRedirect.privacyTitle"
      titleFallback="Privacy Policy"
    />
  );
}
